/**
 * Permisos de Learning (Sol 15/09): GovernancePanel con Andrea Guerra como
 * admin fija. Quien está acá ve el dashboard completo; los líderes ven a su
 * gente por el community map sin pasar por este panel.
 */
import { GovernancePanel } from '@/components/governance/GovernancePanel';
import { useLearningCommunityPicker, useLearningGovernance, useSaveLearningGovernance } from './useLearningGovernance';

export function LearningGovernanceTab() {
  const { data: governance, isLoading, isError } = useLearningGovernance();
  const { data: members = [], isLoading: membersLoading } = useLearningCommunityPicker();
  const save = useSaveLearningGovernance();
  return (
    <GovernancePanel
      namespace="people_learning.governance"
      governance={governance}
      isLoading={isLoading}
      isError={isError}
      members={members}
      membersLoading={membersLoading}
      onSave={(payload, onSuccess) => save.mutate(payload, { onSuccess })}
      saving={save.isPending}
    />
  );
}
